import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChannelStepperService {
	$subject = new Subject<boolean>();

	next(): void {
		return this.$subject.next(true);
	}

	back(): void {
		return this.$subject.next(false);
	}

	goInit(): void {
		return this.$subject.next(undefined);
	}
}
